import React from 'react';
import Table, { TableCell, TableRow } from '@amzn/meridian/table';
import { ContainerDetailsModel } from 'src/components/common/container-details/ContainerDetailsModel';
import { getContainerIdString } from 'src/data-map/containerDetailsToStringID';
import { getChildrenType, getChildrenCount } from 'src/utils/container-details-util';
import * as AppStrings from 'src/localization/string-ids/app-strings';

interface JackpotScanToteInfoTableProps {
    toteDetails: ContainerDetailsModel;
}

class JackpotScanToteInfoTable extends React.Component<JackpotScanToteInfoTableProps> {

    private properties = [
        { key: 'sortationCategories', label: AppStrings.SEARCH_TABLE_SORTATION_CATEGORY },
        { key: 'containerProperties.cleanDecantDate', label: AppStrings.SEARCH_TABLE_CDD },
        { key: 'latestProcessingDate', label: AppStrings.SEARCH_TABLE_LPD },
        { key: 'sla', label: AppStrings.SEARCH_TABLE_SLA },
        { key: 'latestContainerOperation.name', label: AppStrings.SEARCH_TABLE_LATEST_CONTAINER_OPERATION_NAME },
        { key: 'latestContainerOperation.time', label: AppStrings.SEARCH_TABLE_LATEST_CONTAINER_OPERATION_TIME },
        { key: 'latestContainerOperation.associate', label: AppStrings.SEARCH_TABLE_LATEST_CONTAINER_OPERATION_ASSOCIATE }
    ];

    private getPropertyValue = (key: string): unknown => {
        return key.split('.').reduce((acc: any, cur) => acc?.[cur], this.props.toteDetails);
    }

    private getVisibleProperties = () => {
        return this.properties.filter(({key}) => {
            const value = this.getPropertyValue(key);
            return Array.isArray(value) ? value.length > 0 : !!value;
        });
    }

    private getColumnSpan = (): number => {
        const childrenType = getChildrenType(this.props.toteDetails);
        // id column + (optional children-count column) + every visible property + the routing destination column
        return 1 + (childrenType ? 1 : 0) + this.getVisibleProperties().length + 1;
    }

    private renderTitleRow = () => {
        return (
            <TableRow>
                <TableCell columnSpan={this.getColumnSpan()}>
                    {this.props.toteDetails.containerType} Information
                </TableCell>
            </TableRow>
        );
    }

    private renderHeaderRow = () => {
        const childrenType = getChildrenType(this.props.toteDetails);
        return (
            <TableRow>
                <TableCell>{getContainerIdString(this.props.toteDetails.containerType)}</TableCell>
                {childrenType && <TableCell>{childrenType}</TableCell>}
                {this.getVisibleProperties().map(({key, label}) => (
                    <TableCell key={key}>{label}</TableCell>
                ))}
                <TableCell>{AppStrings.SCAN_ITEM_TABLE_ROUTING_DESTINATION}</TableCell>
            </TableRow>
        );
    }

    private renderDataRow = () => {
        const childrenType = getChildrenType(this.props.toteDetails);
        const childrenCount = getChildrenCount(this.props.toteDetails);
        const routingDestination = this.props.toteDetails.containerProperties?.['routingDestination'];

        return (
            <TableRow>
                <TableCell>{this.props.toteDetails.containerId}</TableCell>
                {childrenType && <TableCell>{childrenCount}</TableCell>}
                {this.getVisibleProperties().map(({key}) => {
                    const value = this.getPropertyValue(key);
                    if (key === 'sortationCategories' && Array.isArray(value)) {
                        return <TableCell key={key}>{value.join(', ')}</TableCell>;
                    }
                    return <TableCell key={key}>{String(value)}</TableCell>;
                })}
                <TableCell>{routingDestination ?? AppStrings.NO_DESTINATION_FOUND}</TableCell>
            </TableRow>
        );
    }

    public render() {
        return (
            <div className="scan-lpn-table-container">
                <Table headerRows={2} showDividers={true} spacing="small" className="scan-lpn-table" data-testid="jackpot-scan-tote-info-table">
                    {this.renderTitleRow()}
                    {this.renderHeaderRow()}
                    {this.renderDataRow()}
                </Table>
            </div>
        );
    }
}

export default JackpotScanToteInfoTable;
